<template lang="html">
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Edit Participant</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap v-if="participantChanged != null">
                        <v-flex xs12 md6>
                            <v-text-field v-model="participantChanged.email" label="Email*" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 md6>
                            <v-text-field  v-model="participantChanged.phone" label="Phone*" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 md4>
                            <v-text-field v-model="participantChanged.firstName" label="First name*" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 md4>
                            <v-text-field v-model="participantChanged.middleName" label="Middle name" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 md4>
                            <v-text-field v-model="participantChanged.lastName" label="Last name*" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 md3>
                            <v-text-field v-model="participantChanged.gender" label="Gender*" required></v-text-field>
                        </v-flex>

                        <v-flex xs12 md9>
                            <v-text-field v-model="participantChanged.allergies" label="Dietary Restrictions" required></v-text-field>
                        </v-flex>

                        <v-flex xs12  v-if="$userData.permissions.includes('admin') || $userData.permissions.includes('sales')">
                            <v-select
                                    :items="travelerTypes"
                                    label="Traveler Type *"
                                    v-model="participantChanged.type"
                            ></v-select>
                        </v-flex>

                        <v-flex xs12  v-if="selectedTripData.customOptions != undefined && selectedTripData.customOptions.length > 0">
                            <v-divider></v-divider>
                            <h3>{{selectedTripData.customOptionsTitle}} *</h3>
                            <v-layout row wrap justify-space-around>
                                <v-checkbox v-model="participantChanged.Group" v-for="option in selectedTripData.customOptions"
                                            hide-details :value="option.ID" :label="option.label" ></v-checkbox>

                            </v-layout>
                            <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 md12>

                            <v-radio-group v-if="1==1 || $userData.permissions.includes('admin') || $userData.permissions.includes('sales')" v-model="participantChanged.Occupancy">
                                <v-radio
                                        :label="`Quad Occupancy`"
                                        :value=4
                                        key="quad"
                                ></v-radio>
                                <v-radio
                                        :label="`Triple Occupancy`"
                                        :value=3
                                        key="triple"
                                ></v-radio>
                                <v-radio
                                        :label="`Double Occupancy`"
                                        :value=2
                                        key="double"
                                ></v-radio>
                                <v-radio
                                        :label="`Single Occupancy`"
                                        :value=1
                                        key="single"
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>



                    </v-layout>
                </v-container>
                <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="working" color="blue darken-1" flat @click="closeDialog">Close</v-btn>
                <v-btn :disabled="!isTravelerInfoComplete || working" color="blue darken-1" flat @click="patchParticipant">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


</template>

<script lang="js">
    export default  {
        name: 'participant-edit-form',
        props: ["participant", "hidemc", "dialog"],
        components: {
          },
        mounted() {
        },
        data() {
            return {
                travelerTypes: ['Chaperone','Student','Adult','Minor'],
                participantChanged: null,
                working: false,
                selectedTripData: {}
            }
        },
        watch: {
            participant: function (val) {
                if(val != null) {
                    this.selectedTripData = this.participant.Trip

                    console.log('selected customOptionsSelection', this.participant)
                    this.participantChanged = {

                     "email": this.participant.email,
                        "type": this.participant.type,
                        "Group" : this.participant.Group == undefined ? [] : this.participant.Group,
                    "firstName": this.participant.firstName,
                    "middleName": this.participant.middleName,
                    "lastName" : this.participant.lastName,
                    "phone": this.participant.phone,
                    "gender" : this.participant.gender,
                    "allergies" : this.participant.allergies,
                    "Occupancy" : this.participant.Occupancy
                    }

                }
            },
        },
        methods: {
            closeDialog() {
                this.$emit("closeDialog", "participantEdit")
            },
            patchParticipant(){
                var vueThis = this
                this.dialog = false

                vueThis.working = true
                this.$services.participants.patch(this.participant._id,
                    this.participantChanged).then((result) => {
                    vueThis.$updateParticipant(this.participant._id, result)
                    vueThis.$emit("alertUser", "success", "Participant Updated!!")
                    vueThis.working = false

                }).catch(function (error) {
                    console.error('update Error!', error);
                    vueThis.working = false
                    vueThis.$emit("alertUser", "error", "There was an error processing your request")

                });
            }
        },
        computed: {
            isTravelerInfoComplete() {
                console.log('check traveler info complete')
                if (this.participantChanged != null &&
                    this.participantChanged.email.indexOf("@") != -1 && this.participantChanged.email.indexOf(".") != -1 && this.participantChanged.email.length > 5 &&
                    this.participantChanged.phone.length > 8 &&
                    this.participantChanged.gender.trim().length > 0 &&
                    this.participantChanged.firstName.trim().length > 1 &&
                    this.participantChanged.lastName.trim().length > 2) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
